import { useEffect, useState } from 'react';

// re-implementation of the useWindowSize hook that supports both server and
// client contexts
const useWindowSize = () => {
  // Use a useState hook to set the width and height values for both server and
  // client render contexts. Even though the server is static the same sequence
  // of hooks should run for both renders.
  const [windowSize, setWindowSize] = useState({
    width: typeof window === 'undefined' ? 1200 : window.innerWidth,
    height: typeof window === 'undefined' ? 800 : window.innerHeight,
  });

  const changeWindowSize = () => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  };

  useEffect(() => {
    changeWindowSize();

    window.addEventListener('resize', changeWindowSize);

    // Clean-up the event lisenter. This function is called on "unmount"
    return () => {
      window.removeEventListener('resize', changeWindowSize);
    };
  }, []);

  return windowSize;
};

export default useWindowSize;
